import { schemaProcesses } from "./processes";
import { openDsVarModal } from "../../DsVarModal";
export function getSchemaProcesses(stateModel) {
  return schemaProcesses.filter(item => item.stateModel === stateModel);
}
export function getDefaultSchemaProcess(stateModel) {
  return getSchemaProcesses(stateModel).find(item => item.main) || null;
}
export function getSchemaProcess(stateModel, variableName) {
  return getSchemaProcesses(stateModel).find(item => item.variableName === variableName);
}
export function patchActionsForVariablesSchema(plugin, list, req) {
  var _dataStub$parent, _dataStub$parent2, _state$options;
  // console.log(plugin, list, req);
  const {
    dataStub
  } = req;
  const isSourceProp = (_dataStub$parent = dataStub.parent) === null || _dataStub$parent === void 0 ? void 0 : _dataStub$parent.schema['xy:sourceId'];
  if (!isSourceProp) return;
  const state = (_dataStub$parent2 = dataStub.parent) === null || _dataStub$parent2 === void 0 ? void 0 : _dataStub$parent2.value;
  const stateModel = state === null || state === void 0 || (_state$options = state.options) === null || _state$options === void 0 || (_state$options = _state$options.sourceConfig) === null || _state$options === void 0 ? void 0 : _state$options.stateModel;
  if (!stateModel || !dataStub.id) return;
  const variableName = String(dataStub.id);
  const schemaProcess = getSchemaProcess(stateModel, variableName);
  if (!schemaProcess && variableName !== 'customState') return;
  list.unshift({
    key: 'openVariablesSchema',
    title: '编辑变量类型',
    icon() {
      return this.$createElement('a-icon', {
        props: {
          type: 'edit'
        }
      });
    },
    execute: async () => {
      const res = await openDsVarModal({
        designer: plugin.designer,
        instance: state,
        variableName,
        schemaProcess
      });
      if (res.refresh) {
        plugin.xyPageConfig.pushUndoStateAndRecreateCanvas();
      }
    }
  });
}
//# sourceMappingURL=index.js.map
